// extracted by mini-css-extract-plugin
export var equalColumn = "_g0-0";